import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vueDompurifyHTML from 'vue-dompurify-html'

createApp(App).use(store).use(router).use(vueDompurifyHTML).mount('#app')
